import { type ErrorMessage, type GeospatialFile } from '@lib/GeospatialFile'
import { type GeoSpatialFileType, PlanAsset } from 'api-validations/locutus'

import { type PlanFileReading } from './planEntry'

type Shapefiles = { shp: File; shx: File; dbf?: File }

export type ReadableRequest = {
  readable: true
  from: GeoSpatialFileType
  files: Shapefiles | { zip: File } | { file: File }
}

/**
 * What crusher needs to read a source, or why it cannot be read yet (such as a missing .shx).
 */
export type InspectRequest = ReadableRequest | { readable: false; reasons: readonly ErrorMessage[] }

export const toInspectRequest = ({
  file,
  reading
}: {
  file: GeospatialFile
  reading: PlanFileReading
}): InspectRequest => {
  const parsed =
    reading.assetType === PlanAsset.Prescription ? file.prescription() : file.boundary()

  if (!parsed.valid) return { readable: false, reasons: parsed.errors }

  const { type: from, ...files } = parsed.data
  return { readable: true, from, files }
}
